/**
  * api接口的统一出口
  */

import web from '@/api/web';
import inst from '@/api/inst';
import pub from '@/api/pub.js';
import login from '@/api/login.js';
import mainApi from '@/api/my.js'

// 导出接口
export default {
    web,
    inst,
    pub,
    login,
    mainApi,
}